module.exports = "<div class=\"zoom-message\">Zoom verder in om objecten te tonen</div>"